<template>
  <div class="synk_vuln_table-cell">
    <div class="status" v-if="snykPresence">
      <el-row>
        <span class="body1 tag" :class="vulernableStateText ? vulernableStateText.toLowerCase() : ''">
          {{ vulernableStateText }}
        </span>
      </el-row>
      <el-row type="flex" :gutter="4" class="mt-10 vuln_score">
        <el-col :span="8">H: {{ vulnHighScore }}</el-col>
        <el-col :span="8">M: {{ vulnMedScore }}</el-col>
        <el-col :span="8">L: {{ vulnLowScore }}</el-col>
      </el-row>
    </div>
    <div class="status" v-else>
      <span class="body1 display-inline-block">
        {{ vulnerable }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SnykVulnerableTableCell',
  props: {
    snykPresence: {
      type: Boolean,
      default: false
    },
    vulnLowScore: {
      type: [String, Number]
    },
    vulnMedScore: {
      type: [String, Number]
    },
    vulnHighScore: {
      type: [String, Number]
    },
    vulnerable: {
      type: String
    }
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {},
  computed: {
    vulernableStateText () {
      switch (this.vulnerable) {
        case 'HIGH':
          return 'HIGH'
        case 'MEDIUM':
        case 'MED':
          return 'MODERATE'
        case 'LOW':
          return 'LOW'
        default:
          return 'UNKNOWN'
      }
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

.tag {
  line-height: 20px;
  font-size: 10px;
  box-sizing: border-box;
  border: 1px;
  border-radius: 2px;
  padding: 5px 30px;
  text-align: center;
  font-weight: 700;
  vertical-align: sub;

  &.high {
    color: #ee3354;
    background: #fee5ea;
    border-color: #ee3354;
  }

  &.medium {
    background: #fff5c0;
    color: #ff7302;
  }

  &.low {
    background: #dff6ed;
    color: #00a45f;
  }
}

.vuln_score {
  color: #1a90fa;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/table/cell/SnykVulnerableTableCell.vue